export default __webpack_public_path__ + "static/media/previous.a1dc3fc4.svg";